// extracted by mini-css-extract-plugin
export default {"cell":"Sheets_cell__tFsTm"};